/**
 * enum for setting block alignment, used by setAlignment API
 */
// eslint-disable-next-line etc/no-const-enum
export const enum Alignment {
    /**
     * Align left
     */
    Left,

    /**
     * Align center
     */
    Center,

    /**
     * Align right
     */
    Right,
}
